import React from 'react';
import {translate} from 'react-i18next';
import {compose} from "redux";
import Call from "../../../hocs/call";
import {
    deleteDataflowsDataflow,
    deleteDataflowsSelectedDataflows,
    editDataflowsDataflow,
    hideDataflowsDetailAnnotations,
    hideDataflowsDetailLayoutAnnotations,
    readDataflowsListDataflows,
    showDataflowsDataflowDownload,
    showDataflowsDetailAnnotations,
    showDataflowsDetailLayoutAnnotations,
} from "./actions";
import {connect} from "react-redux";
import CustomArtefactList from "./CustomArtefactList";
import CustomAnnotationList from "../../../components/custom-annotation-list";
import {getStringFromArtefactTriplet} from "../../../utils/sdmxJson";
import LayoutAnnotationList from "../../../components/layout-annotation-list";

const mapStateToProps = state => ({
    dataflows: state.scenes.mappingHandler.dataflowPublishing.dataflows,
    dataflowAnnotations: state.scenes.mappingHandler.dataflowPublishing.dataflowAnnotations,
    dataflowLayoutAnnotations: state.scenes.mappingHandler.dataflowPublishing.dataflowLayoutAnnotations,
    dataflowAnnotationTriplet: state.scenes.mappingHandler.dataflowPublishing.dataflowAnnotationTriplet,
});

const mapDispatchToProps = dispatch => ({
    onDetail: dataflowTriplet => dispatch(editDataflowsDataflow(dataflowTriplet)),
    fetchDataflows: () => dispatch(readDataflowsListDataflows()),
    onDataflowDelete: dataflowTriplet => dispatch(deleteDataflowsDataflow(dataflowTriplet)),
    onAnnotationsShow: (annotations, triplet) => dispatch(showDataflowsDetailAnnotations(annotations, triplet)),
    onAnnotationsHide: () => dispatch(hideDataflowsDetailAnnotations()),
    onLayoutAnnotationsShow: (annotations, triplet) => dispatch(showDataflowsDetailLayoutAnnotations(annotations, triplet)),
    onLayoutAnnotationsHide: () => dispatch(hideDataflowsDetailLayoutAnnotations()),
    onSelectedDataflowsDelete: dataflowTriplets => dispatch(deleteDataflowsSelectedDataflows(dataflowTriplets)),
    onDownloadShow: (dataflowTriplets, lang) => dispatch(showDataflowsDataflowDownload(dataflowTriplets, lang)),
});

const DataflowsList = ({
                           dataflows,
                           onDetail,
                           fetchDataflows,
                           onDataflowDelete,
                           dataflowAnnotations,
                           dataflowLayoutAnnotations,
                           dataflowAnnotationTriplet,
                           onAnnotationsShow,
                           onAnnotationsHide,
                           onLayoutAnnotationsShow,
                           onLayoutAnnotationsHide,
                           onSelectedDataflowsDelete,
                           onDownloadShow,
                       }) => {
    return (
        <Call cb={fetchDataflows} disabled={!!dataflows}>
            <CustomArtefactList
                artefacts={dataflows}
                onDetailShow={onDetail}
                showImportButton={false}
                onDownloadShow={onDownloadShow}
                onDelete={onDataflowDelete}
                onSelectedItemDelete={onSelectedDataflowsDelete}
                onAnnotationsShow={onAnnotationsShow}
                onLayoutAnnotationsShow={onLayoutAnnotationsShow}
            />
            <CustomAnnotationList
                annotations={dataflowAnnotations}
                onClose={onAnnotationsHide}
                title={dataflowAnnotationTriplet
                    ? getStringFromArtefactTriplet(dataflowAnnotationTriplet)
                    : null
                }
            />
            <LayoutAnnotationList
                annotations={dataflowLayoutAnnotations}
                onClose={onLayoutAnnotationsHide}
                title={dataflowAnnotationTriplet
                    ? getStringFromArtefactTriplet(dataflowAnnotationTriplet)
                    : null
                }
            />
        </Call>
    )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(DataflowsList);
